import type { KyInstance } from 'ky';

import qs from 'qs';

import { LatestTermsAndConditions, TermsAndConditions } from './terms-and-conditions.model';
import { CommonQueryParams, CommonResponse } from '../common/common.interface';

export async function getTermsAndConditions(
  httpClient: KyInstance,
  options: CommonQueryParams,
): Promise<CommonResponse<TermsAndConditions>> {
  const searchParams = qs.stringify(options);
  return await httpClient.get('terms-and-conditions-all', { searchParams }).json();
}

export async function getLatestTermsAndConditions(
  httpClient: KyInstance,
  options: CommonQueryParams,
  // it's custom endpoint so the type is differ
): Promise<LatestTermsAndConditions[]> {
  const searchParams = qs.stringify(options);
  return await httpClient.get('terms-and-conditions/latest', { searchParams }).json();
}
